import { render, staticRenderFns } from "./SelfAssessmentHumanResources.vue?vue&type=template&id=1dcf31ca&scoped=true&"
import script from "./SelfAssessmentHumanResources.vue?vue&type=script&lang=js&"
export * from "./SelfAssessmentHumanResources.vue?vue&type=script&lang=js&"
import style0 from "./SelfAssessmentHumanResources.vue?vue&type=style&index=0&id=1dcf31ca&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcf31ca",
  null
  
)

export default component.exports